import styled from 'styled-components'

import MainLayout from '../../layouts/MainLayout'
import { mq, sizes } from '../../theme'
import { RelatedProductsBlock } from '../../components/molecules/RelatedProductsBlock/styled'

export const Layout = styled(MainLayout)`
  @media ${mq(sizes.tablet)} {
    & ${RelatedProductsBlock} {
      border-top-left-radius: 2rem;
      border-top-right-radius: 2rem;
    }
  }
`

export const Main = styled.article`
  border-radius: 2rem;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  padding: 2rem 1rem;

  @media ${mq(sizes.mobile)} {
    padding: 2rem 4rem 4rem;
  }
`
